'use client';

import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { CandidateJobsContract } from '@packages/contracts';

import { JobQueryKeys } from '../query-keys';

type CandidateJobRoute = typeof CandidateJobsContract;
type JobSearchRoute = CandidateJobRoute['search'];
type JobSearchResponse = ClientInferResponseBody<JobSearchRoute, 200>['result'];

export type JobSearchQueryOptions<TData = JobSearchResponse> = UseQueryOptions<
	JobSearchRoute,
	ClientArgs,
	TData
>;

export const createJobSearchQueryOptions = (query: Record<string, unknown>) => ({
	queryData: { query },
	queryKey:  JobQueryKeys.search(query),
});
